import {
  logoDividerStyle,
  logoPrimaryTextStyle,
  logoRowStyle,
  logoGradientTextStyle,
  textLogoA11yProps,
  type TextLogoProps,
} from './textLogoStyles'

/** Charcoal "ask" company mark */
export function AskLinaRowLogoCompany({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'ask',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoPrimaryTextStyle(size, 500), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      ask
    </span>
  )
}

/** Gradient "LINA" product mark */
export function AskLinaRowLogoProduct({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'LINA',
  decorative = false,
}: TextLogoProps) {
  return (
    <span
      className={className}
      style={{ ...logoGradientTextStyle(size, 600), ...style }}
      {...textLogoA11yProps(ariaLabel, decorative)}
    >
      LINA
    </span>
  )
}

/** Horizontal "Ask LINA" full lockup */
export function AskLinaRowLogo({
  className,
  style,
  size = 36,
  'aria-label': ariaLabel = 'Ask LINA',
}: TextLogoProps) {
  // LENS renders a touch smaller than LINA — at equal font-size, solid black
  // text optically reads larger next to the lighter-weight gradient wordmark.
  const productSize = Math.round(size * 0.85)

  return (
    <span
      className={className}
      style={{ ...logoRowStyle(), ...style }}
      {...textLogoA11yProps(ariaLabel)}
    >
      <AskLinaRowLogoCompany size={productSize} decorative />
      <span aria-hidden="true" style={logoDividerStyle(size)} />
      <AskLinaRowLogoProduct size={size} decorative />
    </span>
  )
}
